(function () {
  if (window.__lensAddonGlobalInit) return;
  window.__lensAddonGlobalInit = true;

  function toggleIcon(container, open) {
    if (!container) return;
    const plus = container.querySelector('.icon-plus');
    const minus = container.querySelector('.icon-minus');
    if (plus) plus.style.display = open ? 'none' : 'inline';
    if (minus) minus.style.display = open ? 'inline' : 'none';
  }

  function getLensAddonFromTarget(target) {
    return target.closest('.lens-addon');
  }

  function openPowerPopup() {
    const popup = document.getElementById('lens-power-popup');
    if (!popup) return;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lens-popup-open');
  }

  function closePowerPopup(forceClose) {
    const popup = document.getElementById('lens-power-popup');
    if (!popup) return;

    if (!forceClose && popup.classList.contains('is-open')) {
      return;
    }

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lens-popup-open');
  }

  function checkSpherePopup(lensAddon) {
    const popup = document.getElementById('lens-power-popup');
    if (!popup || !lensAddon) return false;

    const left = lensAddon.querySelector('select[name="properties[sph_l]"]');
    const right = lensAddon.querySelector('select[name="properties[sph_r]"]');

    const leftVal = left && left.value ? parseFloat(String(left.value).replace(',', '.')) : null;
    const rightVal = right && right.value ? parseFloat(String(right.value).replace(',', '.')) : null;

    const isOutOfRange = (val) => val !== null && (val < -6.0 || val > 5.0);
    const shouldOpen = isOutOfRange(leftVal) || isOutOfRange(rightVal);

    if (shouldOpen) {
      openPowerPopup();
    } else {
      closePowerPopup(true);
    }

    return shouldOpen;
  }

  function toggleLensForm(lensAddon) {
    if (!lensAddon) return;

    const rxPanel = lensAddon.querySelector('.lens-addon__rx-panel');
    const gridEl = lensAddon.querySelector('.lens-addon__grid');
    const rxIconContainer = lensAddon.querySelector('.lens-addon__rx-head-row .lens-addon__acc-icon');
    const checked = lensAddon.querySelector('input[name="properties[Gläsertyp]"]:checked');
    const panelInputs = rxPanel ? rxPanel.querySelectorAll('select, input') : [];

    if (!rxPanel) return;

    if (checked && checked.dataset.mode === 'rx') {
      rxPanel.style.display = 'block';
      panelInputs.forEach(function (el) {
        el.disabled = false;
      });

      if (gridEl) gridEl.style.display = 'grid';
      toggleIcon(rxIconContainer, true);
      checkSpherePopup(lensAddon);

      const defaultGlass = lensAddon.querySelector('input[name="properties[glasses]"][value="dünn"]');
      if (defaultGlass) defaultGlass.checked = true;
    } else {
      rxPanel.style.display = 'none';
      panelInputs.forEach(function (el) {
        el.disabled = true;
        if (el.tagName === 'SELECT') el.selectedIndex = 0;
        if (el.type === 'radio' || el.type === 'checkbox') el.checked = false;
      });

      closePowerPopup(true);
    }
  }

  function getExtraVariantInput(form) {
    return (
      form.querySelector('.lens-extra-variant-id') ||
      form.parentElement?.querySelector('.lens-extra-variant-id') ||
      form.closest('.product')?.querySelector('.lens-extra-variant-id') ||
      document.querySelector('.lens-extra-variant-id')
    );
  }

  function getExtraThinVariantInput(form) {
    return (
      form.querySelector('.lens-quality-extra-thin-variant-id') ||
      form.parentElement?.querySelector('.lens-quality-extra-thin-variant-id') ||
      form.closest('.product')?.querySelector('.lens-quality-extra-thin-variant-id') ||
      document.querySelector('.lens-quality-extra-thin-variant-id')
    );
  }

  function getSuperThinVariantInput(form) {
    return (
      form.querySelector('.lens-quality-super-thin-variant-id') ||
      form.parentElement?.querySelector('.lens-quality-super-thin-variant-id') ||
      form.closest('.product')?.querySelector('.lens-quality-super-thin-variant-id') ||
      document.querySelector('.lens-quality-super-thin-variant-id')
    );
  }

  function getCurrentVariantPriceInput(form) {
    return (
      form.querySelector('.current-variant-price') ||
      form.parentElement?.querySelector('.current-variant-price') ||
      form.closest('.product')?.querySelector('.current-variant-price') ||
      document.querySelector('.current-variant-price')
    );
  }

  function shouldHandleLensBundle(form) {
    if (!form || !form.matches('form[action*="/cart/add"]')) return false;

    const lensAddon = form.querySelector('.lens-addon');
    if (!lensAddon) return false;

    const lensType = form.querySelector('input[name="properties[Gläsertyp]"]:checked');
    const extraVariantInput = getExtraVariantInput(form);

    if (!lensType) return false;
    if (lensType.value !== 'Einstärkengläser') return false;
    if (!extraVariantInput || !extraVariantInput.value) return false;

    return true;
  }

  function isFormLocked(form) {
    return form.dataset.lensSubmitting === 'true';
  }

  function lockForm(form) {
    if (isFormLocked(form)) return false;
    form.dataset.lensSubmitting = 'true';
    form.dataset.lensSubmittingAt = String(Date.now());
    return true;
  }

  function unlockForm(form) {
    window.setTimeout(function () {
      form.dataset.lensSubmitting = 'false';
    }, 1200);
  }

  function disableSubmitButton(form) {
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    }
    return submitButton;
  }

  function enableSubmitButton(submitButton) {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.classList.remove('loading');
    }
  }

  function formatEuroFromCents(cents) {
    const amount = (Number(cents) || 0) / 100;
    return amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  async function handleLensBundleSubmit(form) {
    if (!shouldHandleLensBundle(form)) return false;
    if (!lockForm(form)) return true;

    const lensAddon = form.querySelector('.lens-addon');
    const extraVariantInput = getExtraVariantInput(form);
    const extraThinVariantInput = getExtraThinVariantInput(form);
    const superThinVariantInput = getSuperThinVariantInput(form);
    const currentVariantPriceInput = getCurrentVariantPriceInput(form);

    const popupBlocked = checkSpherePopup(lensAddon);
    if (popupBlocked) {
      unlockForm(form);
      return true;
    }

    const submitButton = disableSubmitButton(form);

    try {
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);
      const extraVariantId = extraVariantInput ? extraVariantInput.value : '';

      if (!mainVariantId || !extraVariantId) {
        throw new Error('Missing variant ID');
      }

      const bundleId = 'lens_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

      const properties = {};
      formData.forEach(function (value, key) {
        if (key.indexOf('properties[') === 0 && value !== '') {
          properties[key.replace(/^properties\[/, '').replace(/\]$/, '')] = value;
        }
      });

      properties._bundle_id = bundleId;
      properties._bundle_role = 'parent';

      const selectedQuality = form.querySelector('input[name="properties[glasses]"]:checked');
      const selectedQualityValue = selectedQuality ? selectedQuality.value : 'dünn';

      let addonTotalCents = 0;

      addonTotalCents += 10000;

      if (selectedQualityValue === 'extradünn') {
        addonTotalCents += 5000;
      }

      if (selectedQualityValue === 'superdünn') {
        addonTotalCents += 10000;
      }

      const mainProductPriceCents = currentVariantPriceInput
        ? parseInt(currentVariantPriceInput.value || '0', 10)
        : 0;

      const brutPriceCents = mainProductPriceCents + addonTotalCents;

      properties._brutprice = formatEuroFromCents(brutPriceCents);
      properties._addon_price = formatEuroFromCents(addonTotalCents);

      const items = [
        {
          id: Number(mainVariantId),
          quantity: quantity,
          properties: properties
        },
        {
          id: Number(extraVariantId),
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'child',
            _bundle_type: 'lens'
          }
        }
      ];

      if (
        selectedQualityValue === 'extradünn' &&
        extraThinVariantInput &&
        extraThinVariantInput.value
      ) {
        items.push({
          id: Number(extraThinVariantInput.value),
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'child',
            _bundle_type: 'lens_quality',
            _quality: 'extra_thin'
          }
        });
      }

      if (
        selectedQualityValue === 'superdünn' &&
        superThinVariantInput &&
        superThinVariantInput.value
      ) {
        items.push({
          id: Number(superThinVariantInput.value),
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'child',
            _bundle_type: 'lens_quality',
            _quality: 'super_thin'
          }
        });
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });

      if (!res.ok) {
        const errText = await res.text();
        console.error(errText);
        throw new Error('Add to cart failed');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('open_cart', '1');
      window.location.href = url.toString();

      return true;
    } catch (err) {
      console.error('Lens bundle add failed:', err);
      unlockForm(form);
      enableSubmitButton(submitButton);
      return true;
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('.lens-addon input[name="properties[Gläsertyp]"]')) {
      const lensAddon = getLensAddonFromTarget(e.target);
      toggleLensForm(lensAddon);
    }

    if (
      e.target.matches('.lens-addon select[name="properties[sph_l]"]') ||
      e.target.matches('.lens-addon select[name="properties[sph_r]"]')
    ) {
      const lensAddon = getLensAddonFromTarget(e.target);
      checkSpherePopup(lensAddon);
    }
  });

  document.addEventListener('click', function (e) {
    const resetBtn = e.target.closest('.lens-addon__edit');
    if (resetBtn) {
      e.preventDefault();
      const lensAddon = getLensAddonFromTarget(resetBtn);
      const gridEl = lensAddon ? lensAddon.querySelector('.lens-addon__grid') : null;

      if (gridEl) {
        gridEl.querySelectorAll('select').forEach(function (sel) {
          sel.selectedIndex = 0;
        });
      }

      closePowerPopup(true);
      return;
    }

    const rxHead = e.target.closest('.lens-addon__rx-head-row');
    if (rxHead && !e.target.closest('.lens-addon__edit')) {
      const lensAddon = getLensAddonFromTarget(rxHead);
      const gridEl = lensAddon ? lensAddon.querySelector('.lens-addon__grid') : null;
      const icon = lensAddon ? lensAddon.querySelector('.lens-addon__rx-head-row .lens-addon__acc-icon') : null;

      if (gridEl) {
        const isClosed = gridEl.style.display === 'none';
        gridEl.style.display = isClosed ? 'grid' : 'none';
        toggleIcon(icon, isClosed);
      }
      return;
    }

    const accHead = e.target.closest('.lens-addon__acc-head');
    if (accHead) {
      const content = accHead.nextElementSibling;
      const icon = accHead.querySelector('.lens-addon__acc-icon');

      if (content) {
        const isOpen = content.style.display === 'block';
        content.style.display = isOpen ? 'none' : 'block';
        toggleIcon(icon, !isOpen);
      }
      return;
    }

    if (
      e.target.closest('#lens-power-popup-close') ||
      e.target.closest('#lens-power-popup-back')
    ) {
      e.preventDefault();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const popup = document.getElementById('lens-power-popup');
      if (popup && popup.classList.contains('is-open')) {
        e.preventDefault();
        return;
      }
    }
  });

  document.addEventListener('click', function (e) {
    const submitBtn = e.target.closest('form[action*="/cart/add"] [type="submit"]');
    if (!submitBtn) return;

    const form = submitBtn.form || submitBtn.closest('form');
    if (!shouldHandleLensBundle(form)) return;

    if (isFormLocked(form)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    handleLensBundleSubmit(form);
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!shouldHandleLensBundle(form)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (isFormLocked(form)) return;

    handleLensBundleSubmit(form);
  }, true);

  function initExistingLensAddons() {
    document.querySelectorAll('.lens-addon').forEach(toggleLensForm);
  }

  document.addEventListener('DOMContentLoaded', initExistingLensAddons);
  initExistingLensAddons();
})();